import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icons-train",
  "use": "icons-train-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icons-train\"><polygon fill=\"currentColor\" points=\"12.93 15.96 12.11 15.96 11.93 15.88 8 14.24 8 17.5 12.5 19.5 20.5 15.5 20.5 12.52 13.12 15.87 12.93 15.96\" /><polygon fill=\"currentColor\" points=\"12.71 4.04 12.31 4.04 0.31 9.04 0.31 9.96 3.5 11.29 6 12.33 6 13.41 3.5 12.37 3.5 15.5 6 16.61 6 20 5 22 8 22 7.87 21.73 7 20 7 12.3 11.79 9.91 12.28 9.66 12.72 10.56 8 12.92 8 13.16 12.31 14.96 12.71 14.96 20.5 11.42 23.71 9.96 23.71 9.04 12.71 4.04\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol